/**
 * @generated SignedSource<<324d7fe7a1b8acafd1a784c9cd5a84e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type mostReadWidgetArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "mostReadWidgetArticle";
};
export type mostReadWidgetArticle$key = {
  readonly " $data"?: mostReadWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"mostReadWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mostReadWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "4781dcabbd2d6bb76c84be2dd0f1e953";

export default node;
